import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { LOGOS } from "@/lib/assets";

export default function Nav() {
  const { lang, setLang, t } = useLanguage();
  const location = useLocation();
  const onPartner = location.pathname.startsWith("/partner");
  const onAdmin = location.pathname.startsWith("/admin");

  return (
    <header className="nav-glass fixed top-0 left-0 right-0 z-50">
      <div className="max-w-[1400px] mx-auto h-[72px] px-5 lg:px-12 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center" aria-label="Feaststar">
          <img
            src={LOGOS.wordmark}
            alt="Feaststar"
            className="h-9 lg:h-16 w-auto select-none feaststar-logo lg:-my-2"
            style={{ maxWidth: "110px" }}
            draggable="false"
          />
        </Link>

        <nav className="flex items-center gap-3 lg:gap-8">
          {!onPartner && !onAdmin && (
            <>
              <a href="#how-it-works" data-testid="nav-how" className="hidden md:inline body-md text-primary hover:text-accent transition-colors text-[14px]">
                {t("nav.howItWorks")}
              </a>
              <a href="#download" data-testid="nav-app" className="hidden md:inline body-md text-primary hover:text-accent transition-colors text-[14px]">
                {t("nav.app")}
              </a>
              <Link to="/partner" data-testid="nav-partner-cta" className="nav-pill">
                {t("nav.partner")}
              </Link>
            </>
          )}
          {onPartner && (
            <>
              <Link to="/" data-testid="nav-guests" className="hidden md:inline body-md text-primary hover:text-accent transition-colors text-[14px]">
                {t("nav.forGuests")}
              </Link>
              <a href="#partner-form" data-testid="nav-partner-form" className="nav-pill" style={{ borderColor: "var(--color-accent)", color: "var(--color-accent)" }}>
                {t("nav.partner")}
              </a>
            </>
          )}

          <div className="flex items-center border border-soft rounded-sm overflow-hidden ml-1" data-testid="language-toggle">
            <button
              onClick={() => setLang("de")}
              data-testid="lang-de"
              className={`text-[11px] px-2 py-1.5 tracking-widest transition-colors font-medium ${lang === "de" ? "bg-primary text-bg" : "text-muted hover:text-primary"}`}
              style={lang === "de" ? { background: "var(--color-primary)", color: "var(--color-background)" } : {}}
            >
              DE
            </button>
            <button
              onClick={() => setLang("en")}
              data-testid="lang-en"
              className={`text-[11px] px-2 py-1.5 tracking-widest transition-colors font-medium ${lang === "en" ? "bg-primary text-bg" : "text-muted hover:text-primary"}`}
              style={lang === "en" ? { background: "var(--color-primary)", color: "var(--color-background)" } : {}}
            >
              EN
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}
